import Pinyin from 'tiny-pinyin';

export const getPinyin = (str, isAbbreviation = 0) => {
  if (!str) return '';
  
  // Helper to convert single char to TitleCase pinyin
  const getCharPinyin = (char) => {
    if (/[\u4e00-\u9fa5]/.test(char)) {
      const pinyin = Pinyin.convertToPinyin(char, '', true);
      return pinyin.charAt(0).toUpperCase() + pinyin.slice(1);
    }
    return char;
  };

  if (isAbbreviation === 2) {
    // Mode 2: "Lin Yan (LinYan)" for Chinese segments
    // Replace continuous Chinese segments
    return str.replace(/([\u4e00-\u9fa5]+)/g, (match) => {
      const pinyins = match.split('').map(char => getCharPinyin(char));
      const spaced = pinyins.join(' ');
      const continuous = pinyins.join('');
      return `${spaced} (${continuous})`;
    });
  }

  return str.split('').map(char => {
    if (/[\u4e00-\u9fa5]/.test(char)) {
      const pinyin = Pinyin.convertToPinyin(char, '', true); // lowercase
      if (isAbbreviation === 1) {
        return pinyin.charAt(0).toUpperCase();
      } else {
        return pinyin.charAt(0).toUpperCase() + pinyin.slice(1);
      }
    }
    return char;
  }).join('');
};

export const resizeImage = (file, width, height) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('toBlob failed'));
            return;
          }
          const ext = file.name && file.name.includes('.') ? file.name.split('.').pop() : 'png';
          const type = blob.type || `image/${ext}`;
          const resizedFile = new File([blob], file.name || `logo.${ext}`, { type });
          resolve(resizedFile);
        },
        file.type || 'image/png',
      );
      URL.revokeObjectURL(img.src);
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });

const tools = {
  resizeImage,
  getPinyin
};

export default tools;